import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { state } from "app/resources/globals";
import { ResumenCargaDescarga as Comp } from "./comp";

export interface Props {
    /**idCargaDescarga */
    value: number;
}

const ultimoEscaneo = state.map(x => x.ultimaLecturaCargaDescargaRuta);

/**Muestra información resumen de una carga/descawrga */
export class ResumenCargaZE extends React.PureComponent<Props> {
    idCargaZE = (props: Props) => props.value;
    resumen = createSelectorRx(this.idCargaZE, id => observeResource(resources.CargaZE.ObtenerResumen, id));

    render() {
        const resumen = this.resumen(this.props);
        return <Comp idCargaDescarga={this.props.value} resumen={resumen} ultimoEscaneo={ultimoEscaneo} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/status/items/resumen/index.tsx